import { APP_NAME } from "@constants/app.constants";
import SiteSettingsListComponent from "@screens/site-settings/site-settings-list/site-settings-list.component";
import SiteSettingsCreateComponent from "@screens/site-settings/site-settings-create/site-settings-create.component";
import SiteSettingsEditComponent from "@screens/site-settings/site-settings-edit/site-settings-edit.component";

const siteSettingsRoutes = [
  {
    name: "Site Settings",
    icon: "tool",
    path: "/settings/site-settings",
    component: SiteSettingsListComponent,
  },
  {
    name: `Create Site Setting - ${APP_NAME}`,
    path: "/settings/site-settings/create",
    component: SiteSettingsCreateComponent,
  },
  {
    name: `Edit Site Setting - ${APP_NAME}`,
    path: "/settings/site-settings/edit",
    component: SiteSettingsEditComponent,
  },
];

export default siteSettingsRoutes;
